import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import '@/styles/main.scss';
import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import axiosConfig from './lib/axiosConfig';
import VueClipboard from 'vue-clipboard3';
import VueYandexMetrika from 'vue3-yandex-metrika';
import { router } from './router'; // Импортируем роутер
import i18n from './i18n'; // Импортируем i18n
import { captureUTMs, storeClientID, trackGoal, isTrackingEnabled, getAttributionPayload } from './lib/attribution';
import { API_URL } from '@/config.js';
import { track, EVENTS, trackDirective, trackViewDirective } from './lib/uiTracker';

// Capture UTM parameters from current URL on page load (before any redirects clean them up).
captureUTMs();

const app = createApp(App);

// Используем базовый роутер
app.use(router);

// Подключаем i18n
app.use(i18n);

// Подключаем Vuex store
app.use(store);

// Подключаем дополнительные плагины и глобальные свойства
const options = {
  // Вы можете установить ваши настройки по умолчанию здесь
};
app.use(Toast, options); // Подключаем Toast
app.use(VueClipboard); // Подключаем VueClipboard

// Инициализация глобальных свойств
app.config.globalProperties.$axios = axiosConfig;

// UI-трекинг: $track в любом компоненте + директива v-track на кнопках.
// Схема событий и почему своя таблица, а не цели Метрики — src/lib/uiTracker.js.
app.config.globalProperties.$track = track;
app.config.globalProperties.$EVENTS = EVENTS;
app.directive('track', trackDirective);
app.directive('track-view', trackViewDirective);

app.config.globalProperties.$encodeFilterParameter = function(filters) {
  const filterKeys = Object.keys(filters);
  const encodedParams = filterKeys.map(key => `filters[${encodeURIComponent(key)}]=${encodeURIComponent(filters[key])}`);
  return encodedParams.join('&');
};


// Получение ID для Яндекс Метрики и Google Analytics с сервера и инициализация
store.dispatch('app/fetchConfigData').then(() => {
  const metrikaId = store.state.app.configData.metrika_id;
  const chatbotName = store.state.app.configData.chatbot_name || store.state.app.configData.service_name || '';

  if (metrikaId) {
    app.use(VueYandexMetrika, {
      id: metrikaId,
      router, // Передаем роутер в Yandex Metrika
      env: process.env.NODE_ENV
    });

    // Attribution tracking (Phase 1: only for clipcut)
    if (isTrackingEnabled(chatbotName)) {
      // Kick off the getClientID callback immediately. Most ClipCut users
      // arrive via Telegram login_token deeplink — they never call
      // login/save_user, so we cannot rely on those flows to ship the CID.
      // Instead, dosyl update_attribution as soon as both authToken and CID
      // are available. Backend dedups via UNIQUE(chatbot_name, payment_id).
      storeClientID(metrikaId).then(() => {
        try {
          const authToken = localStorage.getItem('authToken');
          if (!authToken || authToken === 'undefined') return;
          const attribution = getAttributionPayload();
          if (!attribution) return;
          if (!attribution.first_touch && !attribution.last_touch && !attribution.ym_client_id) return;
          axiosConfig.post(API_URL + '?action=update_attribution', {
            params: { attribution },
          }).catch(() => { /* best-effort */ });
        } catch (e) { /* noop */ }
      });

      // view_pricing goal on /subscription route
      router.afterEach((to) => {
        if (to.path === '/subscription') {
          trackGoal(metrikaId, 'view_pricing');
        }
      });
    }
  }

  // Google Analytics (gtag.js)
  const gaId = store.state.app.configData.ga_id;
  if (gaId) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){window.dataLayer.push(arguments);};
    window.gtag('js', new Date());
    window.gtag('config', gaId);
  }
}).catch(error => {
  console.error('Ошибка при получении данных конфигурации', error);
});

// Монтируем приложение
app.mount('#app');
